import React from 'react';
import { t } from '../../../../../i18n';
import ReviewsCarousel from '../../../../components/reviews-carousel';
import './styles.scss';

const Reviews = ({ reviews, isLoading }) => (
  <div className="specific-course-screen__reviews-block">
    <h2 className="specific-course-screen__reviews-block-title">
      {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.REVIEWS.TITLE')}
    </h2>
    <p className="specific-course-screen__reviews-block-description">
      {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.REVIEWS.DESCRIPTION')}
    </p>
    <ReviewsCarousel reviews={reviews} isLoading={isLoading} />
  </div>
);

export default Reviews;
